export const gitCommit = 'c9c98d57'
